import { render, staticRenderFns } from "./RefundPartForm.vue?vue&type=template&id=6856d7d7&scoped=true"
import script from "./RefundPartForm.vue?vue&type=script&lang=js"
export * from "./RefundPartForm.vue?vue&type=script&lang=js"
import style0 from "./RefundPartForm.vue?vue&type=style&index=0&id=6856d7d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6856d7d7",
  null
  
)

export default component.exports